"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshEnv = exports.fetchObvioEnv = exports.getHomeUrl = exports.getHost = exports.getDomain = exports.IS_SERVER = exports.DEPLOYMENT = exports.APP_NAME = exports.OBVIO_URL = exports.STAGE = exports.obvioEnv = void 0;
const crypto_1 = require("@obvio/utils/crypto");
const env_1 = require("@obvio/utils/env");
function obvioEnv() {
    var _a, _b;
    return (_b = (_a = global.__OBVIO_ENV__) !== null && _a !== void 0 ? _a : process.env) !== null && _b !== void 0 ? _b : {};
}
exports.obvioEnv = obvioEnv;
exports.STAGE = (process.env.NEXT_PUBLIC_VERCEL_ENV ||
    process.env.VERCEL_ENV ||
    'development');
exports.OBVIO_URL = {
    development: process.env.NEXT_PUBLIC_OBVIO_URL || `http://localhost:3001`,
    preview: 'https://qa.obvio.app',
    production: 'https://obvio.it',
}[exports.STAGE];
exports.APP_NAME = process.env.NEXT_PUBLIC_VERCEL_GIT_REPO_SLUG ||
    process.env.VERCEL_GIT_REPO_SLUG ||
    'localhost';
exports.DEPLOYMENT = process.env.DEPLOYMENT || process.env.VERCEL_URL || 'localhost';
exports.IS_SERVER = typeof window === 'undefined';
function getDomain() {
    var _a;
    return ((exports.IS_SERVER
        ? process.env.OBVIO_PUBLIC_DOMAIN
        : (_a = window.__OBVIO_ENV__) === null || _a === void 0 ? void 0 : _a.OBVIO_PUBLIC_DOMAIN) || 'localhost');
}
exports.getDomain = getDomain;
function getHost() {
    const domain = getDomain();
    const port = domain === 'localhost' ? `:${process.env.PORT || '3000'}` : '';
    return `${domain}${port}`;
}
exports.getHost = getHost;
function getHomeRootUrl() {
    const host = getHost();
    const protocol = host.startsWith('localhost:') ? 'http' : 'https';
    return `${protocol}://${host}`;
}
function getHomeUrl(url = '') {
    return (/^https?:/u.test(url)
        ? url
        : `${getHomeRootUrl()}/${url.replace(/^\/+/u, '')}`).replace(/\/+$/u, '');
}
exports.getHomeUrl = getHomeUrl;
function fetchObvioEnv({ OBVIO_ID, OBVIO_SECRET_KEY, URL = exports.OBVIO_URL, } = (0, env_1.requireEnv)('OBVIO_ID', 'OBVIO_SECRET_KEY')) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${URL}/api/external/${OBVIO_ID}/env`, {
            headers: { Authorization: `Bearer ${OBVIO_SECRET_KEY}` },
        });
        if (!response.ok) {
            throw new Error(`Status: ${response.status} | ${response.statusText}`);
        }
        return JSON.parse(yield (0, crypto_1.decrypt)(yield response.text(), `${OBVIO_ID}:${OBVIO_SECRET_KEY}`));
    });
}
exports.fetchObvioEnv = fetchObvioEnv;
function updateEnvFromObvio() {
    return __awaiter(this, void 0, void 0, function* () {
        Object.assign(process.env, yield fetchObvioEnv());
    });
}
let inflight;
function refreshEnv(fetchEnv = updateEnvFromObvio) {
    return __awaiter(this, void 0, void 0, function* () {
        if (inflight) {
            yield inflight;
        }
        else if (exports.STAGE !== 'development') {
            const ONE_HOUR = 60 * 60 * 1000;
            const lastFetch = Number.parseInt(process.env.OBVIO_ENV_TIMESTAMP || '0', 10) || 0;
            if (Date.now() - lastFetch > ONE_HOUR) {
                console.debug('Fetching environment variables...');
                inflight = (() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield fetchEnv();
                        console.debug('Environment variables fetched.');
                    }
                    catch (error) {
                        const msg = 'Failed to fetch environment variables!';
                        console.error(msg, error);
                        throw new Error(msg);
                    }
                    process.env.OBVIO_ENV_TIMESTAMP = Date.now().toString();
                    inflight = undefined;
                }))();
                yield inflight;
            }
        }
    });
}
exports.refreshEnv = refreshEnv;
